module.exports = __webpack_public_path__ + "static/media/new-york-10.195b191f.jpg";